module.exports = __webpack_public_path__ + "static/media/responsibility-sustainability.c359c139.jpg";